import { AxiosError, InternalAxiosRequestConfig } from "axios";
import { appConfig } from "@core/configs/appConfig";

/** Django APPEND_SLASH expects collection/detail paths to end with `/`. */
function ensureTrailingSlash(url: string): string {
  const [path, ...queryParts] = url.split("?");
  if (!path || path.endsWith("/")) {
    return url;
  }

  const pathWithSlash = `${path}/`;
  return queryParts.length > 0
    ? `${pathWithSlash}?${queryParts.join("?")}`
    : pathWithSlash;
}

export const requestInterceptor = (config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem(appConfig.auth.storageKey);

  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }

  if (config.url) {
    config.url = ensureTrailingSlash(config.url);
  }

  return config;
};

export const responseInterceptor = (error: AxiosError) => {
  if (error.response?.status === 401) {
    localStorage.removeItem(appConfig.auth.storageKey);
    window.location.href = appConfig.routes.login;
  }

  return Promise.reject(error);
};
